<template>
  <div class="home-page">
    <section class="hero" id="brand-story">
      <h1>{{ page.heading }}</h1>
      <p class="hero__lead">
        滋仙草扎根云南，专注石斛与天麻原浆，盒装与量贩装共六款规格，参数照录自各 SKU 现行包装标签。
      </p>
      <ContactFriend placement="hero" />
      <div class="hero__media">
        <video class="hero__video" controls muted loop playsinline preload="metadata" :poster="logoUrl">
          <source :src="videoUrl" type="video/mp4">
          您的浏览器不支持视频播放，可以
          <a href="/about.html">阅读品牌故事</a>了解滋仙草。
        </video>
      </div>
    </section>

    <section class="highlights">
      <div class="highlight-card">
        <h2>云南产区</h2>
        <p>石斛原料来自云南龙陵的高海拔种植基地，三七来自文山，灵芝来自高黎贡山。</p>
      </div>
      <div class="highlight-card">
        <h2>石斛与天麻原浆</h2>
        <p>紫皮石斛、铁皮石斛与乌天麻三个原料品种的即食原浆，各有盒装与量贩装两种规格。</p>
      </div>
      <div class="highlight-card">
        <h2>产地溯源直播</h2>
        <p>把镜头带到种植基地与加工现场，让原料从哪来可以被看见。</p>
      </div>
    </section>

    <section class="home-block" id="products">
      <h2>匠心产品</h2>
      <p class="home-block__lead">
        六款规格与<a href="/products.html">匠心产品页</a>同一份目录，卡片可直接看到净含量、袋数与配料，
        逐项参数与食用方法见各自详情页。
      </p>
      <ProductCatalog section-id="home" />
    </section>

    <section class="home-block" id="quality">
      <h2>品质信息</h2>
      <p>
        从产区的种植管理到工厂加工，再到产地溯源直播，我们把这些环节讲清楚。更完整的说明见
        <a href="/quality.html">品质信息</a>。
      </p>
    </section>

    <section class="home-block">
      <h2>常见问题</h2>
      <p>
        关于产品规格、购买渠道和如何联系顾问的问题，都整理在
        <a href="/faq.html">常见问题</a>。也可以直接看
        <a href="/contact.html">联系方式</a>。
      </p>
    </section>
  </div>
</template>

<script>
import ContactFriend from '@/components/ContactFriend.vue'
import ProductCatalog from '@/components/ProductCatalog.vue'
import { BRAND_LOGO_URL, COMPANY_VIDEO_URL, resolvePage } from '@/content/siteContent.mjs'

const page = resolvePage('/')

export default {
  name: 'HomeView',
  components: {
    ContactFriend,
    ProductCatalog
  },
  data() {
    return {
      page,
      logoUrl: BRAND_LOGO_URL,
      videoUrl: COMPANY_VIDEO_URL
    }
  }
}
</script>

<style scoped>
.home-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 16px 16px 48px;
  text-align: left;
}

.hero {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 30px rgba(75, 0, 130, 0.08);
  padding: 20px;
  text-align: left;
}

.hero h1 {
  color: #4b0082;
  font-size: 1.5em;
  margin: 0 0 8px;
}

.hero__lead {
  color: #555;
  line-height: 1.8;
  margin: 0;
}

.hero__media {
  margin-top: 16px;
}

.hero__video {
  width: 100%;
  max-height: 420px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  background: #000;
}

.highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.highlight-card {
  background: rgba(75, 0, 130, 0.04);
  border-radius: 16px;
  padding: 18px;
}

.highlight-card h2 {
  color: #4b0082;
  font-size: 1.1em;
  margin: 0 0 6px;
}

.highlight-card p,
.home-block p {
  color: #333;
  line-height: 1.8;
  margin: 0;
}

.home-block {
  background: #fff;
  border-radius: 16px;
  padding: 18px;
  margin-top: 16px;
}

.home-block h2 {
  color: #4b0082;
  font-size: 1.2em;
  margin: 0 0 8px;
}

.home-block__lead {
  margin-bottom: 12px !important;
}

.home-page a {
  color: #6a1bb0;
}
</style>
